import { useEffect, useState, useMemo, useCallback } from "react";
import { postAxios } from "../../util/apiCall";
import moment from "moment";
import { today } from "../../util/formatDate";

export const useKonversiMaterial = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [listData, setListData] = useState();
  const [filterMonth, setFilterMonth] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterYear, setFilterYear] = useState(
    moment().utcOffset("+0700").year()
  );

  const [popUpDetailReject, setPopUpDetailReject] = useState(false);
  const [dataTempDetailProduk, setDataTempDetailProduk] = useState();
  const [titleDetail, setTitleDetail] = useState();

  const [toggle, setToggle] = useState(false);
  const [filterShift, setFilterShift] = useState("Pilih Shift");
  const [filterCustomer, setFilterCustomer] = useState("Pilih Customer");
  const [filterJenis, setFilterJenis] = useState("Pilih Jenis");
  const [filterFrom, setFilterFrom] = useState(today);
  const [filterUntil, setFilterUntil] = useState(today);
  const [popUpFilterRange, setPopUpFilterRange] = useState(false);
  const [isFilterRange, setIsFilterRange] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);

  const [subMenu, setSubMenu] = useState("Injection");
  const [filterPrinting, setFilterPrinting] = useState("Rejection");

  const formatDot = useCallback((value) => {
    return value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }, []);

  const numberWithCommas = useCallback((data) => {
    if (data === null || data === undefined || isNaN(data)) return "0";

    return Number(data).toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }, []);

  const switchDotsAndCommas = useCallback((s) => {
    function switcher(match) {
      return match === "," ? "." : ",";
    }
    return s && s.replaceAll(/\.|\,/g, switcher);
  }, []);

  const TOP_N = 10;

  useEffect(() => {
    setListData();
  }, [subMenu]);

  useEffect(() => {
    if (filterPrinting === "Repair") {
      setToggle(true);
    }
  }, [filterPrinting]);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/rejectionMonitoring`,
      {
        tim: dataUser.tim,
        type: subMenu,
        filterDate: `${filterYear}-${("0" + filterMonth).slice(-2)}`,
        filterShift: filterShift === "Pilih Shift" ? "" : filterShift,
        filterCustomer:
          filterCustomer === "Pilih Customer" ? "" : filterCustomer,
        filterJenis:
          filterJenis === "Pilih Jenis"
            ? ""
            : filterJenis === "VP"
            ? "VP|VENT"
            : filterJenis,
        filterYear: filterYear.toString(),
        isFilterRange: isFilterRange,
        dateFrom: filterFrom,
        dateUntil: filterUntil,
        filterPrinting,
      },
      dataUser.auth,
      setListData,
      ""
    );
    setIsRefresh(false);
  }, [
    filterMonth,
    filterYear,
    filterShift,
    isRefresh,
    filterJenis,
    subMenu,
    filterPrinting,
    filterCustomer,
  ]);

  const dataReduced = useMemo(() => {
    return (
      listData &&
      listData.reduce((obj, item) => {
        let find = obj.find(
          (i) => i.name === item.name && i.color === item.color
        );
        let _d = {
          ...item,
          shiftBreakdown: item.shiftBreakdown
            ? Object.fromEntries(
                Object.entries(item.shiftBreakdown).map(
                  ([rejectId, shifts]) => [rejectId, { ...shifts }]
                )
              )
            : item.shiftBreakdown,
        };
        if (find) {
          find.jumlahBarang =
            Number(find.jumlahBarang) + Number(item.jumlahBarang);
          find.perincianNg = find.perincianNg.concat(item.perincianNg);

          if (item.shiftBreakdown) {
            if (!find.shiftBreakdown) find.shiftBreakdown = {};
            Object.entries(item.shiftBreakdown).forEach(
              ([rejectId, shifts]) => {
                if (!find.shiftBreakdown[rejectId]) {
                  find.shiftBreakdown[rejectId] = {};
                }
                Object.entries(shifts).forEach(([shiftName, val]) => {
                  find.shiftBreakdown[rejectId][shiftName] =
                    Number(find.shiftBreakdown[rejectId][shiftName] || 0) +
                    Number(val || 0);
                });
              }
            );
          }
        } else {
          const sum =
            item &&
            item.perincianNg.reduce(function (s, a) {
              return s + Number(a.totalNG);
            }, 0);
          if (sum > 0) {
            obj.push(_d);
          }
        }
        return obj;
      }, [])
    );
  }, [listData]);

  const sortData = useMemo(() => {
    return (
      dataReduced &&
      [...dataReduced].sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      })
    );
  }, [dataReduced]);

  const handleReset = useCallback(() => {
    setFilterMonth(moment().utcOffset("+0700").month() + 1);
    setFilterYear(moment().utcOffset("+0700").year());
    setFilterShift("Pilih Shift");
    setFilterCustomer("Pilih Customer");
    setIsFilterRange(false);
    setFilterFrom(today);
    setFilterUntil(today);
    setIsRefresh(true);
    setFilterJenis("Pilih Jenis");
  }, []);

  const grandTotalOk = useMemo(() => {
    return (sortData || []).reduce((total, data) => {
      return !toggle
        ? total + (data.berat * data.jumlahBarang) / 1000
        : total + data.jumlahBarang;
    }, 0);
  }, [sortData, toggle]);

  const grandTotalReject = useMemo(() => {
    const result = [];
    sortData &&
      sortData.forEach((data) => {
        data.perincianNg.forEach((element) => {
          if (element.totalNG !== "" && element.id !== "Inject Kosong") {
            if (toggle) {
              result.push({
                id: element.id,
                totalNG: Number(element.totalNG) || 0,
              });
            } else {
              result.push({
                id: element.id,
                totalNG: data.berat
                  ? element.id === "Inject Kosong"
                    ? element.totalNG
                    : element.id === "Cuci Warna"
                    ? (data.berat * 0.4 * element.totalNG) / 1000
                    : (data.berat * element.totalNG) / 1000
                  : 0,
              });
            }
          }
        });
      });
    return result;
  }, [sortData, toggle]);

  const findSameGrandTotalReject = useMemo(() => {
    return (
      grandTotalReject &&
      grandTotalReject.reduce((obj, item) => {
        let find = obj.find((i) => i.id === item.id && i.totalNG !== "");
        let _d = {
          ...item,
        };
        if (find) {
          find.id = item.id;
          find.totalNG = Number(find.totalNG) + Number(item.totalNG);
        } else {
          obj.push(_d);
        }
        return obj;
      }, [])
    );
  }, [grandTotalReject]);

  const { nameProduk, totalHighestReject } = useMemo(() => {
    const nameProdukArr = [];
    const totalHighestRejectArr = [];

    const sortedHighestReject = (sortData || [])
      .map((element) => {
        const sum = element.perincianNg.reduce((s, a) => {
          if (toggle) {
            return Number(s) + Number(a.totalNG);
          }

          return a.id === "Inject Kosong"
            ? Number(s)
            : a.id === "Cuci Warna"
            ? Number(s) + Number(a.totalNG) * 0.4
            : Number(s) + Number(a.totalNG);
        }, 0);

        const total = toggle ? sum : (sum * element.berat) / 1000;

        return { element, total };
      })
      .sort((a, b) => b.total - a.total)
      .slice(0, TOP_N);

    sortedHighestReject.forEach(({ element, total }) => {
      nameProdukArr.push(`${element.name} - ${element.color}`);
      totalHighestRejectArr.push(
        toggle ? total : formatDot(switchDotsAndCommas(numberWithCommas(total)))
      );
    });

    return {
      nameProduk: nameProdukArr,
      totalHighestReject: totalHighestRejectArr,
    };
  }, [sortData, toggle, formatDot, switchDotsAndCommas, numberWithCommas]);

  const buildPrSpChartData = useCallback(
    (filteredPrSpData) => {
      if (!filteredPrSpData || filteredPrSpData.length === 0) {
        return { categories: [], series: [] };
      }

      const categories = filteredPrSpData.map(
        (item) => `${item.name}${item.color ? " - " + item.color : ""}`
      );

      const seriesKeySet = new Set();

      filteredPrSpData.forEach((item) => {
        const sb = item.shiftBreakdown || {};

        const sbRejectIdsWithValidShift = new Set();

        Object.entries(sb).forEach(([rejectId, shifts]) => {
          Object.entries(shifts).forEach(([shiftName, val]) => {
            const isValidShift =
              shiftName &&
              shiftName !== "undefined" &&
              shiftName !== "null" &&
              val > 0;
            if (isValidShift) {
              seriesKeySet.add(`${shiftName} - ${rejectId}`);
              sbRejectIdsWithValidShift.add(rejectId);
            }
          });
        });

        (item.perincianNg || []).forEach((ng) => {
          if (!sbRejectIdsWithValidShift.has(ng.id) && ng.totalNG > 0) {
            seriesKeySet.add(ng.id);
          }
        });
      });

      const seriesKeys = Array.from(seriesKeySet);

      const series = seriesKeys.map((key) => {
        const isKelolosan = key.includes(" - ");

        const data = filteredPrSpData.map((item) => {
          const berat = Number(item.berat || 0);
          const sb = item.shiftBreakdown || {};

          if (isKelolosan) {
            const dashIdx = key.indexOf(" - ");
            const shiftName = key.slice(0, dashIdx);
            const rejectId = key.slice(dashIdx + 3);
            const val = sb[rejectId]?.[shiftName] || 0;
            return toggle ? val : (berat * val) / 1000;
          } else {
            const sbRejectIdsWithValidShift = new Set(
              Object.entries(sb)
                .filter(([, shifts]) =>
                  Object.entries(shifts).some(
                    ([shiftName, val]) =>
                      shiftName &&
                      shiftName !== "undefined" &&
                      shiftName !== "null" &&
                      val > 0
                  )
                )
                .map(([rejectId]) => rejectId)
            );
            if (sbRejectIdsWithValidShift.has(key)) return 0;
            const val = (item.perincianNg || [])
              .filter((n) => n.id === key)
              .reduce((sum, n) => sum + Number(n.totalNG || 0), 0);
            return toggle ? val : (berat * val) / 1000;
          }
        });

        return { name: key, data };
      });

      return { categories, series };
    },
    [toggle]
  );

  const handlePickReject = useCallback(
    (data, jenis, type) => {
      setPopUpDetailReject(true);

      setTitleDetail({ name: data.name, color: data.color, jenis: jenis });
      if (type === "all") {
        let findSameProdukDetail = [];
        let tempJumlah = 0;
        sortData &&
          sortData.forEach((element) => {
            if (data.name === element.name && data.color === element.color) {
              element &&
                element.perincianNg.forEach((ele) => {
                  const ngValue = Number(ele.totalNG) || 0;

                  if (toggle) {
                    if (ngValue) {
                      tempJumlah += ngValue;
                    }
                  } else {
                    if (ngValue) {
                      if (ele.id !== "Inject Kosong") {
                        if (ele.id !== "Cuci Warna") {
                          tempJumlah += ngValue;
                        } else {
                          tempJumlah += ngValue * 0.4;
                        }
                      }
                    }
                  }
                });
              findSameProdukDetail.push({
                berat: element.berat,
                color: element.color,
                customer: element.customer,
                date: "",
                id: element.id,
                jumlahBarang: element.jumlahBarang,
                material: element.material,
                mesin: element.mesin,
                name: element.name,
                perincianNg: [{ id: "", totalNG: tempJumlah }],
                tim: element.tim,
                total: element.total,
                all: true,
              });
            }
          });

        setDataTempDetailProduk(findSameProdukDetail);
      } else {
        let findSameProdukDetail = [];
        listData &&
          listData.forEach((element) => {
            let check =
              element && element.perincianNg.find((o) => o.id === jenis);

            if (
              data.name === element.name &&
              data.color === element.color &&
              check
            ) {
              findSameProdukDetail.push(element);
            }
          });
        setDataTempDetailProduk(findSameProdukDetail);
      }
    },
    [sortData, listData, toggle]
  );

  return {
    dataUser,
    sortData,
    filterMonth,
    setFilterMonth,
    filterYear,
    setFilterYear,
    handleReset,
    findSameGrandTotalReject,
    handlePickReject,
    popUpDetailReject,
    setPopUpDetailReject,
    dataTempDetailProduk,
    titleDetail,
    nameProduk,
    totalHighestReject,
    formatDot,
    numberWithCommas,
    switchDotsAndCommas,
    toggle,
    setToggle,
    filterShift,
    setFilterShift,
    filterFrom,
    setFilterFrom,
    filterUntil,
    setFilterUntil,
    setIsFilterRange,
    popUpFilterRange,
    setPopUpFilterRange,
    setIsRefresh,
    subMenu,
    setSubMenu,
    filterJenis,
    setFilterJenis,
    buildPrSpChartData,
    filterPrinting,
    setFilterPrinting,
    TOP_N,
    filterCustomer,
    setFilterCustomer,
    grandTotalOk,
  };
};
